import { render, staticRenderFns } from "./CoTwoPremiseForm.vue?vue&type=template&id=40396c14&"
import script from "./CoTwoPremiseForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoPremiseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40396c14')) {
      api.createRecord('40396c14', component.options)
    } else {
      api.reload('40396c14', component.options)
    }
    module.hot.accept("./CoTwoPremiseForm.vue?vue&type=template&id=40396c14&", function () {
      api.rerender('40396c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoPremiseForm.vue"
export default component.exports